import { motion } from "framer-motion";

const variants = {
  initial: {
    opacity: 0,
    y: 12,                 // less movement = smoother
    scale: 0.995,          // subtle depth
    filter: "blur(6px)",
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,       // slower = premium
      ease: [0.22, 1, 0.36, 1], // easeOutExpo-like
    },
  },
  exit: {
    opacity: 0,
    y: -12,
    scale: 0.995,
    filter: "blur(6px)",
    transition: {
      duration: 0.7,       // not rushed
      ease: [0.4, 0, 0.2, 1], // smooth in-out
    },
  },
};

export default function PageTransition({ children }) {
  return (
    <motion.main
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{
        willChange: "transform, opacity, filter",
      }}
    >
      {children}
    </motion.main>
  );
}
